import { render } from "./classLibraryAdd.vue?vue&type=template&id=cbf86f72&scoped=true"
import script from "./classLibraryAdd.vue?vue&type=script&lang=js"
export * from "./classLibraryAdd.vue?vue&type=script&lang=js"

import "./classLibraryAdd.vue?vue&type=style&index=0&id=cbf86f72&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbf86f72"]])

export default __exports__